export default __webpack_public_path__ + "static/media/MessinaSans-SemiBold.41d8ad78.woff2";